















































import Vue from 'vue'
import { ProductState, ProductDetailModel } from '@/product/types'

export default Vue.extend({
  computed: {
    product(): ProductDetailModel {
      return (this.$store.state as ProductState).productDetail
    },
    disableLink(): boolean {
      return !this.$store.getters.isSendable
    },
    linkToEstimatePreview(): string {
      const addonPsi = this.$store.getters.addonProductPsi || ''
      return `${this.product.product.id}/estimate_preview?printable_sku_id=${this.product.printableSkuId}&sizes=${this.$store.getters.sizeInputQuery}&addonPsi=${addonPsi}&optionIds=${this.selectedAdditionalOptions}`
    },
    selectedAdditionalOptions(): string {
      return (this.$store.state as ProductState).selectedAdditionalOptionIds.map(option => option).join(',')
    }
  },
  methods: {
    onAddToEstimate() {
      if (!this.$store.getters.isSendable) return
      this.$store.dispatch('addToEstimate')
    }
  }
})
